import { createSelector } from "reselect";
import { State } from "../constants";

const getScheduleState = ({ schedule }: State) => schedule;

export const scheduleStatus = createSelector(
  getScheduleState,
  ({ activeInterval }) => activeInterval
);
